import React from "react";
import { cn } from "../../utils/utils";
import { SpaceIcon } from "lucide-react";
import Winner from "../../assets/icons/winner.svg";
import FinalWinner from "../../assets/icons/card_crown.svg";
type Props = {
  data: any;
  type: "Semi" | "Quarter" | "Round16" | "Round32";
  isWinner?: boolean;
  placeType?: "final" | "third place";
  SemiFinalData?:any;
  getTeamPosition?:any
};

function ChartTeamMatchBox({
  data,
  type,
  isWinner = false,
  placeType = "final",
  SemiFinalData,
  getTeamPosition,
}: Props) {

  
const getLoserId = (stageIndex:number)=>{
   const loser = SemiFinalData[stageIndex]?.team_line_ids.find((data:any)=>  data?.team_id?.id!==SemiFinalData[stageIndex].winner?.id) 
   return loser?.team_id?.id
}
const getWinnerId =(stageIndex:number)=>(SemiFinalData[stageIndex]?.winner
                                ?.id)
  return (
    <div
      className={cn(
        "team--box--shadow flex-1 border-2 bg-[#F9FBFF] rounded-[12px]  h-full flex justify-center items-center relative flex-col gap-1 min-h-[90px] ",
        placeType === "final" ? "border-primary mb-5" : "border-primaryRed z-20 w-full lg:w-[80%] mx-auto"
      )}
    >
      {isWinner && (
        <div>
          <img loading="lazy"
            src={FinalWinner}
            alt=""
            width={50}
            height={50}
            className="absolute  left-[50%] translate-x-[-50%] -top-10"
          />
        </div>
      )}
      <div
        className={cn(
          placeType === "final" ? "winner_banner" : "third_banner",
          "  rounded-t-lg rounded-b-none absolute grid place-content-center w-[calc(100%+20px)] -left-[10px] h-[6vh] min-h-[15px] top-[14px]  ",
          type === "Semi" &&
            "before:border-[5px] before:w-[10px] before:h-[10px] after: after:border-[5px] after:w-[10px] after:h-[10px]",
          type === "Quarter" &&
            "before:border-[5px] before:w-[10px] before:h-[10px] after: after:border-[5px] after:w-[10px] after:h-[10px]",
          placeType === "final"
            ? "bg-primaryYellow"
            : "bg-primaryRed text-white"
        )}
      >
        {data?.winner?.name || data?.match_code}
      </div>
      <div className="scores pt-[calc(16px+6vh)] font-digital">
        {!data?.winner?.id ? (
          <span className="text-primary dark:text-white text-center text-xl">
            - - -
          </span>
        ) : (
          <span className="text-primary dark:text-white text-center text-2xl font-bold flex gap-2 items-center ">
            <ul className="left-team-score flex gap-1">
              <li>{data.team_line_ids[getTeamPosition(isWinner?getWinnerId(0):getLoserId(0), data) || 0].score_1}</li>
              {parseInt(data.set_per_match) !== 1 && (
                <>
                  <li className="font-sans">-</li>
                  <li>{data.team_line_ids[getTeamPosition(isWinner?getWinnerId(0):getLoserId(0), data)].score_2}</li>
                  <li className="font-sans">-</li>
                  <li>{data.team_line_ids[getTeamPosition(isWinner?getWinnerId(0):getLoserId(0), data)].score_3}</li>
                </>
              )}
            </ul>
            <span> -</span>
            <ul className="right-team-score flex gap-1">
              <li>{data.team_line_ids[getTeamPosition(isWinner?getWinnerId(1):getLoserId(1), data)].score_1}</li>
              {parseInt(data.set_per_match) !== 1 && (
                <>
                  <li className="font-sans">-</li>
                  <li>{data.team_line_ids[getTeamPosition(isWinner?getWinnerId(1):getLoserId(1), data)].score_2}</li>
                  <li className="font-sans">-</li>
                  <li>{data.team_line_ids[getTeamPosition(isWinner?getWinnerId(1):getLoserId(1), data)].score_3}</li>
                </>
              )}
            </ul>
          </span>
        )}
      </div>
      <div className="teams flex gap-2 items-center text-sm ">
        <span className="team-name flex gap-2 items-center">
          {data?.winner?.id &&
            data?.winner?.id === data?.team_line_ids[getTeamPosition(isWinner?getWinnerId(0):getLoserId(0), data)]?.team_id?.id && (
              <span>
                <img loading="lazy" src={Winner} alt="" width={20} height={20} />
              </span>
            )}
          {data?.team_line_ids[getTeamPosition(isWinner?getWinnerId(0):getLoserId(0), data)]?.team_id?.name}
        </span>
        <span className="team-name flex gap-2  items-center justify-center bg-[#f3f3f3] rounded-full w-6 h-6 text-secondary">
          vs
        </span>
        <span className="team-name flex gap-2 items-center">
          {data?.team_line_ids[getTeamPosition(isWinner?getWinnerId(1):getLoserId(1), data)]?.team_id?.name}
          {data?.winner?.id &&
            data?.winner?.id === data?.team_line_ids[getTeamPosition(isWinner?getWinnerId(1):getLoserId(1), data)]?.team_id?.id && (
              <span>
                <img loading="lazy" src={Winner} alt="" width={20} height={20} />
              </span>
            )}
        </span>
      </div>
    </div>
  );
}

export default ChartTeamMatchBox;
